import { Stack, Typography } from "@mui/material";
import { OopsIcon } from "../images";
import { Link } from "react-router-dom";
import { AppRoutes } from "../../types/enums";
import { CustomButton } from "./CustomButton";
import React from "react";

export const OopsBlock = ({ campaign_id }: { campaign_id: string }) => {
  return (
    <Stack
      sx={{
        px: { sm: 8, md: 8, lg: 10, xl: 20 },
        minHeight: "Calc(100vh - 74px)",
      }}
      justifyContent={"center"}
      alignItems={"center"}
      gap={"40px"}
    >
      <Stack gap="20px" justifyContent={"center"} alignItems={"center"}>
        <OopsIcon />
        <Stack
          gap="12px"
          justifyContent={"center"}
          maxWidth={"492px"}
          alignItems={"center"}
        >
          <Typography
            sx={{
              color: "#232323",
              fontSize: "34px",
              fontWeight: 600,
              lineHeight: "44px",
            }}
          >
            Oops, something went wrong
          </Typography>
          <Stack gap="24px" maxWidth={"440px"} alignItems={"center"}>
            {[
              "We encounted an unexpected error while processing your request. ",
              "BCR team has been automatically notified and is already working on fixing the issue. ",
              "If it is client critical or unfixed for more than 3 business days, please contact BCR team via ",
            ].map((text, i) => (
              <Typography
                key={i}
                sx={{
                  color: "#232323",
                  fontSize: "16px",
                  fontWeight: 400,
                  lineHeight: "24px",
                  textAlign: "center",
                }}
              >
                {text}
                {i === 2 && (
                  <span style={{ color: "#2194D2" }}> Helpdesk.</span>
                )}
              </Typography>
            ))}
          </Stack>
        </Stack>
      </Stack>
      <Link to={`${AppRoutes.ACCOUNTS_LIST}/${campaign_id}`}>
        <CustomButton customSize="fit" customColor="#1C3C6C">
          Back to Account
        </CustomButton>
      </Link>
    </Stack>
  );
};
